function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 283.5L55.5 148.8l-.7-1.2c-27.2-47.1-11-107.2 36-134.4C105.8 4.5 122.9 0 140.3 0h2.9c54.3-.2 98.5 43.7 98.7 98.1.1 17.4-4.5 34.4-13.2 49.5l-1 1.8-86 134.1zM80 134.3l61.7 96.3 61.7-96.3.6-1c19.3-33.5 7.9-76.3-25.6-95.6-10.7-6.2-22.8-9.4-35.2-9.4h-2.9c-38.6-.1-70.1 31.1-70.2 69.8 0 12.4 3.2 24.5 9.4 35.2l.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 133.5c-26.4 0-44.1-17.1-44.1-42.6s17.7-42.6 44.1-42.6 44.1 17.1 44.1 42.6-17.7 42.6-44.1 42.6zm0-56.6c-15.6 0-15.6 9.9-15.6 14.1 0 9.6 4.9 14.1 15.6 14.1 15.6 0 15.6-9.9 15.6-14.1 0-14.1-10.9-14.1-15.6-14.1z"
})));